import { render, staticRenderFns } from "./SalesCrm.vue?vue&type=template&id=1afe5395&"
import script from "./SalesCrm.vue?vue&type=script&lang=js&"
export * from "./SalesCrm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports